export default __webpack_public_path__ + "static/media/up-example.f125a31d.png";